import SRS from "../../../../services/StudentRecordService";
import isAudioDisabledDistrict from "../licensing/studentAudioLicense";

/**
 * The main function for fetching the comprehension report data
 * @param {*} ...
 * @returns 
 */
 export default async function fetchComprehensionReport(activityId, phraseIndex, student) {
  try {
    const excludeAudio = isAudioDisabledDistrict();
    const response = await SRS.getActivity(activityId, excludeAudio);
    const activity = filterDialogsForPhrase(response.data.getActivity[0], phraseIndex);
    const studentLicense = await SRS.getEntitlements(activity.districtId, activity.schoolId);

    const userStandardSet = studentLicense?.sorConfig?.selectedStandard;
    const chapterItem = activity.story.chapters[0].items[phraseIndex];
    const standardMapping = chapterItem.interactions[0].standardMapping.find(mapping => mapping.standardSet === userStandardSet);

    const report = {
      header: await getHeader(student, activity.createdAt, activity.studentId),
      story: getStory(activity.story),
      standard: getStandard(standardMapping),
      score: getScore(activity),
      why: getWhy(standardMapping),
      dialog: getDialog(activity),
    };

    console.log("Comprehension Report: ", report);
    return report;
  } catch(error) {
    console.error('An error occurred:', error);
    return { error }
  };
}

function filterDialogsForPhrase(activity, phraseIndex) {
  const newActivity = { ...activity };
  newActivity.comprehensionDialog = newActivity.comprehensionDialog.filter(dialog => dialog.phraseIndex === phraseIndex);
  return newActivity;
}

async function getHeader(student, date, studentId) {
  return {
    student: {
      studentId,
      firstName: student ? student.firstName : "Student",
      lastName: student ? student.lastName : "",
    },
    date
  };
}

function getStory(story) {
  return story;
}

function getStandard(standardMapping) {
  return {
    title: standardMapping?.standardId,
    description: standardMapping?.description,
  }
}

function getScore(activity) {
  return {
    numerator: activity.comprehensionDialog[0].score,
    denominator: 10
  };
}

function getWhy(standardMapping) {
  return standardMapping?.reason;
}

function getDialog(activity) {
  return activity.comprehensionDialog;
}